import { Navigate, useParams } from "react-router-dom";
import { useLang } from "@/lib/i18n";

// Consent is now given by pressing Start on the instrument page. Old links and
// sessions parked on this step go back there to start (and consent) afresh.
export default function Consent() {
  const { slug } = useParams();
  const { lp } = useLang();
  return <Navigate to={lp(`/instruments/${slug}`)} replace />;
}
